import release from '../../release/version.json';

/**
 * App version A.B.C.D — A.B is the store release, C.D the live-update
 * number (see release/README.md). Store builds embed the file as it was at
 * release time; GitHub Actions writes the live number into it before each
 * live update is bundled.
 */
export const STORE_VERSION = `${release.store.major}.${release.store.minor}`;
export const APP_VERSION = `${STORE_VERSION}.${release.live.series}.${release.live.count}`;

/** In-app payment on iOS: off for App Review, turned on by a live update
 * after approval (node scripts/release.js ios-approved). */
export const IOS_BILLING_ENABLED = release.iosBillingEnabled === true;
